import { useMutation } from "react-query";

import forgetpassword from "../services/forgetPassword";

function useForgetPasswordMutation() {
  return useMutation(["ForgetPassword"], forgetpassword);
}

export default useForgetPasswordMutation;
